export const ADMIN_SERVICE_URL = '/mrhs-admin'
export const ADMIN_URL = '/mrhs-admin/admin'
export const AUTH_URL = '/mrhs-auth'